import client from './client';
import type { AdminDashboardStats, AdminUser, AdminReport, AdminNode } from '../types/admin';
import type { PaginatedResponse } from '../types/api';

export async function getDashboard(): Promise<AdminDashboardStats> {
  const { data } = await client.get('/admin/dashboard');
  return data;
}

export async function getUsers(
  page: number,
  limit: number,
  search?: string
): Promise<PaginatedResponse<AdminUser>> {
  const { data } = await client.get('/admin/users', {
    params: { page, limit, search },
  });
  return data;
}

export async function getUser(id: string): Promise<AdminUser> {
  const { data } = await client.get(`/admin/users/${id}`);
  return data;
}

export async function updateUser(
  id: string,
  payload: { role?: string; isBlocked?: boolean; hwidExempt?: boolean }
): Promise<AdminUser> {
  const { data } = await client.patch(`/admin/users/${id}`, payload);
  return data;
}

/** Отвязать устройство у ключа подписки (DELETE → 204) */
export async function unbindKeyDevice(keyId: string): Promise<void> {
  await client.delete(`/admin/vpn-keys/${keyId}/device`);
}

/** Отвязать устройство у триального ключа юзера (DELETE → 204) */
export async function unbindTrialDevice(userId: string): Promise<void> {
  await client.delete(`/admin/users/${userId}/trial/device`);
}

export async function getReports(): Promise<AdminReport[]> {
  const { data } = await client.get('/admin/reports');
  return data || [];
}

export async function respondToReport(
  id: string,
  response: string
): Promise<AdminReport> {
  const { data } = await client.patch(`/admin/reports/${id}`, {
    status: 'answered',
    response,
  });
  return data;
}

export interface WeeklyRevenueItem {
  week: string;
  revenue: number;
}

export async function getWeeklyRevenue(weeks: number = 4): Promise<WeeklyRevenueItem[]> {
  const { data } = await client.get('/admin/dashboard/revenue', { params: { weeks } });
  return data || [];
}

export async function getNodes(): Promise<AdminNode[]> {
  const { data } = await client.get('/admin/nodes');
  return data || [];
}
